module.exports = __webpack_public_path__ + "static/media/people living on mars.7b272284.jpeg";